import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Solidify from '../views/Solidify.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/solidify',
    name: 'Solidify',
    component: Solidify,
    children: [
      {
        path: '',
        name: 'SolidifyLearner',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyLearner" */ '../views/Learner_Landing.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'selectTask',
        name: 'SolidifyLearnerSelectTask',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyLearnerSelectTask" */ '../views/Learner_Select_Task.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'submitTask',
        name: 'SolidifyLearnerSubmitTask',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyLearnerSubmitTask" */ '../views/Learner_Submit_Task.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'peerReview',
        name: 'SolidifyLearnerPeerReview',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyLearnerPeerReview" */ '../views/Learner_Peer_Review.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'proxyReview',
        name: 'SolidifyLearnerProxyReview',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyLearnerProxyReview" */ '../views/Learner_Proxy_Review.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'status',
        name: 'SolidifyLearnerStatus',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyLearnerStatus" */ '../views/Learner_Check_Status.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'done',
        name: 'SolidifyLearnerDone',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyLearnerDone" */ '../views/Learner_Done.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'rereview',
        name: 'LearnerRereview',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "LearnerRereview" */ '../views/Learner_Rereview.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'gating',
        name: 'SolidifyLearnerGating',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyLearnerGating" */ '../views/Learner_Gating.vue'),
      },
      {
        path: 'Error',
        name: 'SolidifyLearnerError',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyLearnerError" */ '../views/Error.vue'),
      },
      {
        path: 'systemUnderMaintenance',
        name: 'SystemUnderMaintenance',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SystemUnderMaintenance" */ '../views/System_Under_Maintenance.vue'),
      },
      {
        path: 'about',
        name: 'SolidifyAbout',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAbout" */ '../views/About.vue'),
      },
      {
        path: 'administration',
        name: 'SolidifyAdministration',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministration" */ '../views/Admin/Operational_Tab.vue'),
      },
      {
        path: 'administration/OperationalTabDetails',
        name: 'SolidifyAdministrationOperationalDetails',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationOperationalDetails" */ '../views/Admin/Operational_Tab_Details.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/learnerevents',
        name: 'SolidifyAdministrationLearnerEvents',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationLearnerEvents" */ '../views/Admin/Learner_Events.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/Learnergrades',
        name: 'SolidifyAdministrationLearnerGrades',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationLearnerGrades" */ '../views/Admin/Learner_Grades.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/taskManagement',
        name: 'SolidifyAdministrationTaskManagement',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationTaskManagement" */ '../views/Admin/Task_Management.vue'),
      },
      {
        path: 'administration/genAIReviewedSubmissions',
        name: 'SolidifyAdministrationGenAIReviewedSubmissions',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationGenAIReviewedSubmissions" */ '../views/Admin/GenAIReviewedSubmissions.vue'),
      },
      {
        path: 'administration/taskDetails',
        name: 'SolidifyAdministrationTaskDetails',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationTaskDetails" */ '../views/Admin/Task_Details.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/systemSetting',
        name: 'SolidifyAdministrationSystemSetting',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationSystemSetting" */ '../views/Admin/System_Setting.vue'),
      },

      {
        path: 'administration/manageProxy',
        name: 'SolidifyAdministrationManageProxy',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationManageProxy" */ '../views/Admin/Manage_Proxy.vue'),
      },
      {
        path: 'administration/assignProxy',
        name: 'SolidifyAdministrationAssignProxy',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationAssignProxy" */ '../views/Admin/Assign_Proxy.vue'),
      },
      {
        path: 'administration/viewProxyRequests',
        name: 'SolidifyAdministrationViewProxyRequests',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationViewProxyRequests" */ '../views/Admin/View_Proxy_Requests.vue'),
      },
      {
        path: 'administration/viewAllProxyRequests',
        name: 'SolidifyAdministrationViewAllProxyRequests',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationViewAllProxyRequests" */ '../views/Admin/View_All_Proxy_Requests.vue'),
      },
      {
        path: 'administration/viewAllProgramProxyAssignment',
        name: 'SolidifyAdministrationViewAllProgramProxyAssignment',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationViewAllProxyRequests" */ '../views/Admin/View_All_Programs_Proxy_Assignments.vue'),
      },
      {
        path: 'administration/viewRereviewRequests',
        name: 'SolidifyAdministrationViewRereviewRequests',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationViewRereviewRequests" */ '../views/Admin/View_Rereview_Requests.vue'),
      },
      {
        path: 'administration/emailTemplateManagement',
        name: 'SolidifyAdministrationEmailTemplateManagement',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationEmailTemplateManagement" */ '../views/Admin/Email_Template_Management.vue'),
      },
      {
        path: 'administration/emailTemplateDetails',
        name: 'SolidifyAdministrationEmailTemplateDetails',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationEmailTemplateManagement" */ '../views/Admin/Email_Template_Details.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/viewEmailQueue',
        name: 'SolidifyAdministrationViewEmailQueue',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationViewEmailQueue" */ '../views/Admin/View_Email_Queue.vue'),
      },
      {
        path: 'administration/programAdministration',
        name: 'SolidifyAdministrationProgramAdministration',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationProgramAdministration" */ '../views/Admin/Program_Administration.vue'),
      },
      {
        path: 'administration/masterAdministration',
        name: 'SolidifyAdministrationMasterAdministration',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationMasterAdministration" */ '../views/Admin/Master.vue'),
      },
      {
        path: 'administration/programDetails',
        name: 'SolidifyAdministrationProgramDetails',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationProgramDetails" */ '../views/Admin/Program_Details.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/manageEmailTemplates',
        name: 'SolidifyAdministrationManageEmailTemplates',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationProgramDetails" */ '../views/Admin/Manage_Program_Email_templates.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/assignRoleToUser',
        name: 'SolidifyAdministrationAssignRoleToUser',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationAssignRoleToUser" */ '../views/Admin/AssignRoleToUser.vue'),
      },
      {
        path: 'administration/sendEmailToUser',
        name: 'SolidifyAdministrationsendEmailToUser',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationsendEmailToUser" */ '../views/Admin/SendEmailToUser.vue'),
      },
      {
        path: 'administration/createOffcycle',
        name: 'SolidifyAdministrationCreateOffCycle',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationCreateOffCyele" */ '../views/Admin/CreateOffCycle.vue'),
        // props: true,
      },
      {
        path: 'administration/uploadSubmission',
        name: 'SolidifyAdministrationUploadSubmission',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationCreateOffCyele" */ '../views/Admin/UploadSubmission.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/harvestReport',
        name: 'SolidifyAdministrationharvestReport',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationharvestReport" */ '../views/Admin/Harvest_Report.vue'),
        // props: true,
      },
      {
        path: 'administration/needReviewerReport',
        name: 'SolidifyAdministrationNeedReviewerReport',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationNeedReviewerReport" */ '../views/Admin/Reviewer_Report.vue'),
        // props: true,
      },
      {
        path: 'administration/plagiarsimReport',
        name: 'SolidifyAdministrationPlagiarsimReport',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationPlagiarsimReport" */ '../views/Admin/Plagiarsim_Report.vue'),
        // props: true,
      },
      {
        path: 'administration/feedbackReport',
        name: 'SolidifyAdministrationfeedbackReport',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationPlagiarsimReport" */ '../views/Admin/Feedback_Report.vue'),
        // props: true,
      },
      {
        path: 'administration/createOffCycles',
        name: 'SolidifyAdministrationCreateOffCycles',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationNeedReviewerReport" */ '../views/Admin/Create_OffCycles.vue'),
        // props: true,
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/updateSubmission',
        name: 'SolidifyAdministrationUpdateSubmission',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationCreateOffCyele" */ '../views/Admin/UpdateSubmission.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/OffcycleDetails',
        name: 'SolidifyAdministrationOffCycleDetails',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationOperationalDetails" */ '../views/Admin/OffcycleDetails.vue'),
        props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/offcycledashboard',
        name: 'SolidifyAdministrationOffcycleDashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationOffcycleDashboard" */ '../views/Admin/offcycleDashboard.vue'),
        props: (route) => ({ query: route.query }),
      },

      //Segmented Comms
      {
        path: 'administration/learners/emailTemplateManagement',
        name: 'SolidifyAdministrationLearnersEmailTemplateManagement',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationEmailTemplateManagement" */ '../views/Admin/Learners_Email_Template_Management.vue'),
      },
      {
        path: 'administration/managers/emailTemplateManagement',
        name: 'SolidifyAdministrationManagersEmailTemplateManagement',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationEmailTemplateManagement" */ '../views/Admin/Managers_Email_Template_Management.vue'),
      },
      {
        path: 'administration/bulkUpload/validation',
        name: 'SolidifyAdministrationBulkUploadValidation',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationEmailTemplateManagement" */ '../views/Admin/bulkUploadValidation.vue'),
        // props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/bulkUploadData/test',
        name: 'SolidifyAdministrationBulkUploadDataTest',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationEmailTemplateManagement" */ '../views/Admin/bulkUploadDataTest.vue'),
        // props: (route) => ({ query: route.query }),
      },
      {
        path: 'administration/bulkUploadData/process',
        name: 'SolidifyAdministrationBulkUploadDataProcess',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "SolidifyAdministrationEmailTemplateManagement" */ '../views/Admin/bulkUploadDataProcess.vue'),
        // props: (route) => ({ query: route.query }),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

export default router;
